import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Transition as _Transition, vShow as _vShow, withDirectives as _withDirectives, renderSlot as _renderSlot, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "fixed inset-0 flex" }
const _hoisted_2 = { class: "absolute right-0 top-0 flex w-16 justify-center pt-5" }
const _hoisted_3 = { class: "flex grow flex-col gap-y-5 overflow-y-auto bg-white px-6 ring-1 ring-white/10" }
const _hoisted_4 = { class: "flex h-16 shrink-0 items-center" }
const _hoisted_5 = { class: "grid grid-cols-1 gap-y-3 h-full" }
const _hoisted_6 = { class: "relative mt-auto py-1.5 space-y-2" }
const _hoisted_7 = { class: "flex items-center transition rounded-lg group shrink-0" }
const _hoisted_8 = {
  key: 0,
  class: "ml-2 text-xs text-left sm:block truncate"
}
const _hoisted_9 = { class: "hidden xl:fixed xl:inset-y-0 xl:z-50 xl:flex xl:w-72 xl:flex-col" }
const _hoisted_10 = { class: "flex grow flex-col gap-y-5 overflow-y-auto bg-white px-6 ring-1 ring-white/5" }
const _hoisted_11 = { class: "flex h-16 shrink-0 items-center" }
const _hoisted_12 = { class: "flex flex-1 flex-col" }
const _hoisted_13 = { class: "md:space-y-1" }
const _hoisted_14 = { class: "md:px-1 py-1.5" }
const _hoisted_15 = { class: "flex flex-col lg:py-1.5 gap-4 lg:gap-2" }
const _hoisted_16 = { class: "xl:pl-72" }
const _hoisted_17 = { class: "sticky top-0 z-40 flex justify-end h-16 shrink-0 items-center gap-x-6 border-b border-white/5 bg-white px-4 shadow-sm sm:px-6 lg:px-8" }
const _hoisted_18 = { class: "hidden xl:flex items-center justify-end gap-2" }
const _hoisted_19 = { class: "bg-blue-4 min-h-[calc(100vh-4rem)] p-4 md:p-6 lg:p-8" }

import { useStore } from "vuex";
import { onMounted, ref, watch, onBeforeUnmount } from "vue";

import { useRouter } from "vue-router";
import { XMarkIcon } from "@heroicons/vue/24/outline";
import "reflect-metadata";
import NotificationsView from "@/features/notifications/views/NotificationsView.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'LayoutRecruit',
  setup(__props) {

const store = useStore();
const isLoaded = ref(false);
const router = useRouter();
const host = window.location.host;
const parts = host.split(".");
const subdomain = parts[0];
const isDevOrStaging =
  subdomain.includes("min-dev") || subdomain.includes("min-staging");

const onLogout = async () => {
  await store.dispatch("logout");
  router.push("/admin/login");
};

const onChangePassword = () => {
  router.push("/admin/change-password");
};

watch(
  () => router.currentRoute.value.name,
  () => {
    sidebarOpen.value = false;
  }
);

const sidebarOpen = ref(false);

onMounted(async () => {
  isLoaded.value = true;
});

const menuOpen = ref(false);
const menuContainer = ref(null);

const toggleMenu = () => {
  menuOpen.value = !menuOpen.value;
};

const onClickOutsideMenu = (event: any) => {
  if (menuContainer.value && !menuContainer.value.contains(event.target)) {
    menuOpen.value = false;
  }
};

// Lyssna på klickhändelser på dokumentet
onMounted(() => {
  document.addEventListener("click", onClickOutsideMenu);
});

// Ta bort klickhändelselyssnare när komponenten avmonteras
onBeforeUnmount(() => {
  document.removeEventListener("click", onClickOutsideMenu);
});

return (_ctx: any,_cache: any) => {
  const _component_TransitionChild = _resolveComponent("TransitionChild")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_DialogPanel = _resolveComponent("DialogPanel")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_TransitionRoot = _resolveComponent("TransitionRoot")!
  const _component_LinkButton = _resolveComponent("LinkButton")!
  const _component_MenuButton = _resolveComponent("MenuButton")!
  const _component_MenuItem = _resolveComponent("MenuItem")!
  const _component_MenuItems = _resolveComponent("MenuItems")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_vue_notification_list = _resolveComponent("vue-notification-list")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[18] || (_cache[18] = _createElementVNode("link", {
      href: "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.6.0/css/all.min.css",
      rel: "stylesheet"
    }, null, -1)),
    _createElementVNode("div", null, [
      _createVNode(_component_TransitionRoot, {
        as: "template",
        show: sidebarOpen.value
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Dialog, {
            as: "div",
            class: "relative z-50 xl:hidden",
            onClose: _cache[1] || (_cache[1] = ($event: any) => (sidebarOpen.value = false))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_TransitionChild, {
                as: "template",
                enter: "transition-opacity ease-linear duration-300",
                "enter-from": "opacity-0",
                "enter-to": "opacity-100",
                leave: "transition-opacity ease-linear duration-300",
                "leave-from": "opacity-100",
                "leave-to": "opacity-0"
              }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createElementVNode("div", { class: "fixed inset-0 bg-gray-900/80" }, null, -1)
                ]))]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_TransitionChild, {
                  as: "template",
                  enter: "transition ease-in-out duration-300 transform",
                  "enter-from": "-translate-x-full",
                  "enter-to": "translate-x-0",
                  leave: "transition ease-in-out duration-300 transform",
                  "leave-from": "translate-x-0",
                  "leave-to": "-translate-x-full"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DialogPanel, { class: "relative flex w-full max-w-xs flex-1" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "-m-2.5 p-2.5",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (sidebarOpen.value = false))
                          }, [
                            _cache[3] || (_cache[3] = _createElementVNode("span", { class: "sr-only" }, "Close sidebar", -1)),
                            _createVNode(_unref(XMarkIcon), {
                              class: "h-6 w-6 text-gray-900",
                              "aria-hidden": "true"
                            })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_3, [
                          _createElementVNode("div", _hoisted_4, [
                            _createVNode(_component_router_link, { to: "/" }, {
                              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                _createElementVNode("img", {
                                  src: "/images/logo.svg",
                                  class: "h-8 w-auto"
                                }, null, -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("nav", _hoisted_5, [
                            _cache[8] || (_cache[8] = _createElementVNode("ul", { class: "space-y-0.5" }, [
                              _createElementVNode("li", { class: "px-1 py-1.5" }, [
                                _createElementVNode("p", { class: "inline-block text-xs px-3 uppercase text-darkGray-4" }, " category.category "),
                                _createElementVNode("ul", { class: "flex flex-col py-1.5 gap-2" }, [
                                  _createElementVNode("li", { class: "px-3 py-1.5 rounded-md" }, [
                                    _createElementVNode("button", null, [
                                      _createElementVNode("div", { class: "flex items-center justify-start" }, [
                                        _createElementVNode("span", { class: "flex items-center justify-center flex-shrink-0 w-6 h-6" }, [
                                          _createElementVNode("i", { class: "text-xl fas" })
                                        ]),
                                        _createElementVNode("span", { class: "inline-block ml-3 text-sm truncate" }, "item.name")
                                      ])
                                    ])
                                  ])
                                ])
                              ])
                            ], -1)),
                            _createElementVNode("ul", _hoisted_6, [
                              _createElementVNode("li", _hoisted_7, [
                                (_unref(store).state.userStore.token !== null)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_8, [...(_cache[5] || (_cache[5] = [
                                      _createElementVNode("strong", { class: "block font-medium truncate" }, "Förnamn Efternamn", -1)
                                    ]))]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", { class: "ml-auto flex items-center text-gray-600" }, [
                                  _createElementVNode("button", {
                                    onClick: onChangePassword,
                                    class: "ml-2 hover:text-gray-900",
                                    title: "Byt Lösenord"
                                  }, [...(_cache[6] || (_cache[6] = [
                                    _createElementVNode("i", { class: "fas fa-key" }, null, -1)
                                  ]))]),
                                  _createElementVNode("button", {
                                    onClick: onLogout,
                                    class: "ml-2 hover:text-gray-900",
                                    title: "Logga ut"
                                  }, [...(_cache[7] || (_cache[7] = [
                                    _createElementVNode("i", { class: "fas fa-sign-out-alt" }, null, -1)
                                  ]))])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["show"]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_router_link, { to: "/" }, {
              default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                _createElementVNode("img", {
                  src: "/images/logo.svg",
                  alt: "logo",
                  class: "h-8 w-auto"
                }, null, -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("nav", _hoisted_12, [
            _createVNode(_component_LinkButton, {
              "style-type": "cta",
              icon: "plus",
              text: "Skapa annons",
              to: {
              name: 'formbuilderPicker',
            },
              class: "mb-4 -mt-1 w-full flex place-content-center"
            }),
            _createElementVNode("ul", _hoisted_13, [
              _createElementVNode("li", _hoisted_14, [
                _cache[13] || (_cache[13] = _createElementVNode("p", { class: "hidden lg:inline-block text-xs md:px-3 uppercase text-darkGray-4" }, " Välkommen! ", -1)),
                _createElementVNode("ul", _hoisted_15, [
                  _createElementVNode("li", {
                    class: _normalizeClass([{ 'bg-blue-4': _ctx.$route.name === 'RecruitHome' }, "md:px-3 py-1.5 rounded-md"])
                  }, [
                    _createVNode(_component_router_link, {
                      to: { name: 'RecruitHome' },
                      class: _normalizeClass({
                      'text-blue-1': _ctx.$route.name === 'RecruitHome',
                      'text-darkGray-3 hover:bg-blue-4':
                        _ctx.$route.name !== 'RecruitHome',
                    })
                    }, {
                      default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                        _createElementVNode("div", { class: "flex items-center justify-center lg:justify-start" }, [
                          _createElementVNode("span", { class: "flex items-center justify-center flex-shrink-0 w-6 h-6" }, [
                            _createElementVNode("i", { class: "text-2xl lg:text-xl fas fa-house" })
                          ]),
                          _createElementVNode("span", { class: "hidden lg:inline-block ml-3 text-sm" }, " Hem ")
                        ], -1)
                      ]))]),
                      _: 1
                    }, 8, ["class"])
                  ], 2),
                  _createElementVNode("li", {
                    class: _normalizeClass([{ 'bg-blue-4': _ctx.$route.name === 'MyProfile' }, "md:px-3 py-1.5 rounded-md"])
                  }, [
                    _createVNode(_component_router_link, {
                      to: "/minasidor",
                      class: _normalizeClass({
                      'text-blue-1': _ctx.$route.name === 'MyProfile',
                      'text-darkGray-3 hover:bg-blue-4':
                        _ctx.$route.name !== 'MyProfile',
                    })
                    }, {
                      default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                        _createElementVNode("div", { class: "flex items-center justify-center lg:justify-start" }, [
                          _createElementVNode("span", { class: "flex items-center justify-center flex-shrink-0 w-6 h-6" }, [
                            _createElementVNode("i", { class: "text-2xl lg:text-xl fas fa-user" })
                          ]),
                          _createElementVNode("span", { class: "hidden lg:inline-block ml-3 text-sm" }, " Mina sidor ")
                        ], -1)
                      ]))]),
                      _: 1
                    }, 8, ["class"])
                  ], 2),
                  _createElementVNode("li", {
                    class: _normalizeClass([{ 'bg-blue-4': _ctx.$route.name === 'RecruitChat' }, "md:px-3 py-1.5 rounded-md"])
                  }, [
                    _createVNode(_component_router_link, {
                      to: "/recruit-chat",
                      class: _normalizeClass({
                      'text-blue-1': _ctx.$route.name === 'RecruitChat',
                      'text-darkGray-3 hover:bg-blue-4':
                        _ctx.$route.name !== 'RecruitChat',
                    })
                    }, {
                      default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                        _createElementVNode("div", { class: "flex items-center justify-center lg:justify-start" }, [
                          _createElementVNode("span", { class: "flex items-center justify-center flex-shrink-0 w-6 h-6" }, [
                            _createElementVNode("i", { class: "text-2xl lg:text-xl fas fa-message" })
                          ]),
                          _createElementVNode("span", { class: "hidden lg:inline-block ml-3 text-sm" }, " Meddelanden ")
                        ], -1)
                      ]))]),
                      _: 1
                    }, 8, ["class"])
                  ], 2)
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _cache[17] || (_cache[17] = _createElementVNode("div", { class: "inline-flex items-center rounded-md bg-yellow-50 px-2 py-1 text-xs font-medium text-yellow-800 ring-1 ring-inset ring-yellow-600/20 truncate sm:min-w-max" }, [
            _createElementVNode("p", { class: "truncate" }, "Testmiljö - ej riktig data")
          ], -1)),
          _createElementVNode("div", _hoisted_18, [
            _createVNode(NotificationsView),
            _createVNode(_component_Menu, {
              as: "div",
              class: "relative"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(_component_MenuButton, {
                    class: "flex items-center transition rounded-lg group shrink-0",
                    onClick: toggleMenu
                  }, {
                    default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                      _createElementVNode("p", { class: "ml-2 text-xs text-left sm:block" }, [
                        _createElementVNode("strong", { class: "block font-medium truncate" }, " Förnamn Efternamn ")
                      ], -1),
                      _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        class: "w-5 h-5 ml-2 text-darkGray-2 transition sm:block group-hover:text-darkGray-1",
                        viewBox: "0 0 20 20",
                        fill: "currentColor"
                      }, [
                        _createElementVNode("path", {
                          "fill-rule": "evenodd",
                          d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
                          "clip-rule": "evenodd"
                        })
                      ], -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _withDirectives(_createVNode(_Transition, {
                  "enter-active-class": "transition duration-100 ease-out",
                  "enter-from-class": "transform scale-95 opacity-0",
                  "enter-to-class": "transform scale-100 opacity-100",
                  "leave-active-class": "transition duration-75 ease-in",
                  "leave-from-class": "transform scale-100 opacity-100",
                  "leave-to-class": "transform scale-95 opacity-0"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_MenuItems, { class: "absolute right-0 mt-3 w-56 origin-top-right divide-y text-gray-600 divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none overflow-hidden" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_MenuItem, null, {
                          default: _withCtx(() => [
                            _createElementVNode("button", {
                              onClick: onChangePassword,
                              class: "group flex w-full items-center px-2 py-2 text-sm transition group gap-x-3 p-2 leading-6"
                            }, [...(_cache[15] || (_cache[15] = [
                              _createElementVNode("div", {
                                class: "h-6 w-6 shrink-0",
                                "aria-hidden": "true"
                              }, [
                                _createElementVNode("i", { class: "fas fa-key" })
                              ], -1),
                              _createElementVNode("p", null, "Byt lösenord", -1)
                            ]))])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_MenuItem, null, {
                          default: _withCtx(() => [
                            _createElementVNode("button", {
                              onClick: onLogout,
                              class: "group flex w-full items-center px-2 py-2 text-sm transition group gap-x-3 p-2 leading-6"
                            }, [...(_cache[16] || (_cache[16] = [
                              _createElementVNode("div", {
                                class: "h-6 w-6 shrink-0",
                                "aria-hidden": "true"
                              }, [
                                _createElementVNode("i", { class: "fas fa-sign-out-alt" })
                              ], -1),
                              _createElementVNode("p", null, "Logga ut", -1)
                            ]))])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, menuOpen.value]
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("main", _hoisted_19, [
          _renderSlot(_ctx.$slots, "default"),
          _createVNode(_component_vue_notification_list, { position: "bottom-right" })
        ])
      ])
    ])
  ], 64))
}
}

})